import loadable from '@loadable/component'
import {RouteConfig} from 'react-router-config'

export default [
  {
    path: '/medal',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-medal-index" */ '~/pages/Medal/pages/index'
        )
    ),
  },
  // 标题勋章
  {
    path: '/titleMedal',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-MedalTitle-index" */ '~/pages/MedalTitle/pages/index'
        )
    ),
  },
  // 标题勋章 详情
  {
    path: '/titleMedal/detail',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-MedalTitle-index-Details" */ '~/pages/MedalTitle/pages/index/Details'
        )
    ),
  },
] as RouteConfig[]
